import React, { useEffect, useState } from "react";
import { Form, Input, Row, Col, Card, Table, Typography, Button, InputNumber, Popconfirm, Space, Select, Modal, DatePicker, Divider, AutoComplete } from "antd";
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import TextArea from "antd/es/input/TextArea";
import { QuotationService } from "../../../Services/Manage/QuotationService";
import useMessage from "antd/es/message/useMessage";
import { LetterService } from "../../../Services/Manage/LetterService";
import { ENDPOINT } from "../../../Services/ENDPOINT";
import { UserService } from "../../../Services/Manage/UserService";
import { BankService } from "../../../Services/Manage/BankService";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { InvoiceService } from "../../../Services/Manage/InvoiceService";
import CreatePayment from "../../modals/CreatePayment";
import { EnquiryService } from "../../../Services/Manage/EnquiryService";
import html2pdf from 'html2pdf.js';
import QuotationInvoiceTemplate from "../template/QuotationInvoiceTemplate";



const AddInvoiceData = ({
    Eqslected,
    invoice_no,
    data,
    rowData,
    eqData
}) => {
    const { Text, Title } = Typography;
    const [form] = Form.useForm();
    const [footerForm] = Form.useForm();
    const [dataSource, setDataSource] = useState([]);
    const [count, setCount] = useState(3);
    const [grandTotal, setGrandTotal] = useState(0);
    const [message, msgContc] = useMessage();
    const [letterHead, setLetterHead] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedTCOption, setSelectedTCOption] = useState([]);
    const [dgSign, setDGsign] = useState(null);
    const [dgSignOption, setDGsignOption] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedValue, setSelectedValue] = useState(null);
    const [bankAc, setBankAc] = useState(null);
    const [bankAcOption, setBankAcOption] = useState([]);
    const navigate = useNavigate();
    const [printInvoice, setPrintInvoice] = useState(false);

    const [paymentModalOpen, setPaymentModalOpen] = useState(false);
    const [quotationNo, setQuotationNo] = useState(null);
    const [options, setOptions] = useState([]);
    const taxOptions = ["GST", "VAT", "Service Tax", "Excise", "Custom Duty"];
    const handleSearch = (value) => {
        setOptions(
            value
                ? taxOptions
                    // .filter((tax) => tax.toLowerCase().includes(value.toLowerCase()))
                    .map((tax) => ({ value: tax }))
                : []
        );
    };

    const handlePreview = () => {
        if (selectedValue) {
            setIsModalOpen(true);
        }
    };

    // console.log(data, selectedDate);

    const getAllLetterhead = async () => {
        try {
            const request = await LetterService.getAllHead();
            const options = request.data.map((item) => ({
                label: item.tag,
                value: item.id,
                ...item,
            }));
            setLetterHead(options);

            if (data?.header_id) {
                const defaultHeader = options.find((option) => option.value === Number(data.header_id));
                if (defaultHeader) {
                    setSelectedOption(defaultHeader);
                }
            }
        } catch (error) {
            console.error(error);
        }
    };

    const getBankAcOption = async () => {
        try {
            const request = await BankService.getAllBank();
            const options = request.data.map((item) => ({
                label: item.tag,
                value: item.id,
                ...item,
            }));
            setBankAcOption(options);

            if (data?.bank_id) {
                const defaultBank = options.find((option) => option.value === Number(data.bank_id));
                if (defaultBank) {
                    setBankAc(defaultBank);
                    footerForm.setFieldsValue({ bank_ac: defaultBank.value });
                }
            }
        } catch (error) {
            console.error(error);
        }
    };

    const getAllTCData = async () => {
        try {
            const response = await LetterService.getAllTC();
            const options = response.data.map((item) => ({
                label: item.tag,
                value: item.id,
                ...item,
            }));
            setSelectedTCOption(options);

            if (data?.tc_id) {
                const defaultTC = options.find((option) => option.value === Number(data.tc_id));
                if (defaultTC) {
                    setSelectedValue(defaultTC);
                }
            }
        } catch (error) {
            console.error(error);
        }
    };

    const getDigitalSign = async () => {
        try {
            const response = await QuotationService.getDigitalSign();
            const options = response.data.map((item) => ({
                label: (
                    <img
                        src={`${ENDPOINT.base}/${item.image_path}`}
                        alt={`Signature ${item.id}`}
                        style={{ width: "100px", height: "auto", objectFit: "contain" }}
                    />
                ),
                value: item.id,
                title: `Signature ${item.id}`,
                ...item,
            }));
            setDGsignOption(options);

            if (data?.sign_id) {
                const defaultSign = options.find((option) => option.value === Number(data.sign_id));
                if (defaultSign) {
                    setDGsign(defaultSign);
                }
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getAllLetterhead();
        getAllTCData();
        getBankAcOption();
        getDigitalSign();
        form.setFieldsValue({
            quotationNo: data?.quotationNo,
            gstNo: data?.cus_gst,
            tax_id: data?.tax_id,
            tax_type: data?.tax_type
        });

        // Ensure bank_ac is set in footerForm
        if (data?.bank_id) {
            footerForm.setFieldsValue({
                bank_ac: Number(data.bank_id),
            });
        }

        // Assign unique keys to rowData items if missing
        const dataWithKeys = rowData.map((item, index) => ({
            ...item,
            key: item.key ?? (item.id ?? `temp_${index}`),
        }));
        setDataSource(dataWithKeys);

        // Set count to the next available value based on max key (assuming numeric keys)
        const maxKey = dataWithKeys.reduce((max, item) => {
            const itemKey = Number(item.key);
            return isNaN(itemKey) ? max : Math.max(max, itemKey);
        }, 0);
        setCount(maxKey + 1);

        if (data?.invoice_date) {
            setSelectedDate(data.invoice_date);
        }
    }, [data, form, rowData, footerForm]);

    const numberToWords = (num) => {
        const a = [
            "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten",
            "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"
        ];
        const b = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
        const g = ["", "Thousand", "Million", "Billion"];

        if (num === 0) return "Zero";

        let str = "";
        let grp = 0;

        while (num > 0) {
            let chunk = num % 1000;
            if (chunk) {
                let chunkStr = "";
                if (chunk > 99) {
                    chunkStr += a[Math.floor(chunk / 100)] + " Hundred ";
                    chunk %= 100;
                }
                if (chunk > 19) {
                    chunkStr += b[Math.floor(chunk / 10)] + " ";
                    chunk %= 10;
                }
                if (chunk > 0) chunkStr += a[chunk] + " ";
                str = chunkStr + g[grp] + " " + str;
            }
            num = Math.floor(num / 1000);
            grp++;
        }
        return str.trim();
    };

    useEffect(() => {
        calculateGrandTotal();
    }, [dataSource]);

    const handleDelete = async (record) => {
        if (record.id) {
            // Existing row: delete from server and filter by id
            try {
                const request = await QuotationService.deleteQuotation(record.id);
                if (request.status) {
                    const newData = dataSource.filter((item) => item.id !== record.id);
                    setDataSource(newData);
                    message.success(request.message);
                } else {
                    message.error(request.message);
                }
            } catch (error) {
                console.error(error);
                message.error("Failed to delete row");
            }
        } else {
            // New row: just remove locally by key
            const newData = dataSource.filter((item) => item.key !== record.key);
            setDataSource(newData);
            message.success("Row deleted");
        }
    };


    const handleChange = (key, field, value) => {
        const newData = dataSource.map((item) => {
            if (item.key === key) {
                const updatedItem = { ...item, [field]: value };
                const basePrice = updatedItem.qty * updatedItem.unitprice;
                const taxPercent = updatedItem.tax || 0;
                const total = basePrice + (basePrice * taxPercent) / 100;

                updatedItem.totalprice = Math.round(total);

                return updatedItem;
            }
            return item;
        });
        setDataSource(newData);
    };


    const calculateGrandTotal = () => {
        const total = dataSource.reduce((sum, item) => sum + (item.totalprice || 0), 0);
        setGrandTotal(total);
    };

    const columns = [
        {
            title: "SI No",
            dataIndex: "key",
            width: '7%',
            align: 'center',
            key: "key",
            render: (_, __, index) => index + 1,
        },
        {
            title: "Description",
            dataIndex: "description",
            key: "description",
            render: (text, record) => (
                <TextArea
                    allowClear
                    rows={2}
                    value={text}
                    onChange={(e) => handleChange(record.id ?? record.key, "description", e.target.value)}

                />
            ),
        },
        {
            title: "Qty",
            dataIndex: "qty",
            width: '12%',
            align: 'center',
            key: "qty",
            render: (text, record) => (
                <InputNumber
                    min={0}
                    value={text}
                    onChange={(value) => handleChange(record.id ?? record.key, "qty", value)}
                />
            ),
        },
        {
            title: "Unit Price",
            dataIndex: "unitprice",
            align: 'center',
            width: '12%',
            key: "unitprice",
            render: (text, record) => (
                <InputNumber
                    min={0}
                    value={text}
                    onChange={(value) => handleChange(record.id ?? record.key, "unitprice", value)}
                />
            ),
        },
        {
            title: "Tax (in %)",
            dataIndex: "tax",
            width: '12%',
            align: 'center',
            key: "tax",
            render: (text, record) => (
                <InputNumber
                    min={0}
                    value={text}
                    onChange={(value) => handleChange(record.id ?? record.key, "tax", value)}
                />
            ),
        },
        {
            title: "Total Price",
            dataIndex: "totalprice",
            align: 'center',
            key: "totalprice",
            render: (text) => <Text>{text}</Text>,
            width: '10%'
        },
        {
            title: "Action",
            key: "action",
            align: 'center',
            width: 120,
            render: (_, record) => (
                <>
                    <Button
                        disabled={!Eqslected}
                        icon={<PlusOutlined />}
                        type="dashed"
                        size="large"
                        style={{ marginRight: 8 }}
                        onClick={() => handleAdd(record.id ?? record.key)}
                    />
                    <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record)}>
                        <Button disabled={!Eqslected} icon={<DeleteOutlined />} danger />
                    </Popconfirm>
                </>
            ),
        },
    ];

    const handleNewAdd = () => {
        setDataSource([...dataSource, {
            key: count,
            description: "",
            qty: 1,
            unitprice: 0,
            totalprice: 0
        }]);
        setCount(count + 1);
    };

    // const handleAdd = (key) => {
    //     const newRow = { key: count, description: "", qty: 1, unitprice: 0, totalprice: 0 };
    //     const index = dataSource.findIndex((item) => item.key === key);

    //     let newData = [...dataSource];
    //     newData.splice(index + 1, 0, newRow);
    //     setDataSource(newData);
    //     setCount(count + 1);
    // };
    const handleAdd = (identifier) => {
        const newRow = { key: count, description: "", qty: 1, unitprice: 0, totalprice: 0 };

        // Find the index using id if exists, otherwise key
        const index = dataSource.findIndex((item) => item.id === identifier || item.key === identifier);

        let newData = [...dataSource];
        newData.splice(index + 1, 0, newRow);
        setDataSource(newData);
        setCount(count + 1);
    };


    const handleSave = async () => {
        try {
            console.log("Saved Data:", dataSource);

            // if (!selectedOption?.id) {
            //     return message.warning("Please Select Quotation");
            // }
            // if (!selectedValue?.id) {
            //     return message.warning("Please Select Quotation");
            // }
            // if (!dgSign?.id) {
            //     return message.warning("Please Select Sign");
            // }
            if (!dataSource || dataSource.length <= 0) {
                return message.warning("Please Add contents");
            }
            // if (!bankAc?.value) {
            //     return message.warning("Please Select Bank Account");
            // }

            const request = form.getFieldsValue();
            console.log("Request:", request);
            console.log(selectedDate);

            const formattedData = dataSource.map(({ key, ...rest }) => ({
                ...rest,
                qu_no: eqData.qu_no
            }));

            const user = await UserService.getOmeUser();
            console.log(data.qu_no);

            const data_insert = {
                // qu_no: data?.qu_no,
                // eq_no: data?.eq_no,
                // date: selectedDate,
                // cus_gst: request?.gstNo,
                tax_id: request?.tax_id,
                tax_type: request?.tax_type,
                // header_id: selectedOption.id,
              tc_id: selectedValue?.id ?? null,
sign_id: dgSign?.id ?? null,
                added_by: user.uid,
            bank_id: bankAc?.value ?? null,
            };

            console.log("data_insert", data_insert);

            console.log("Formatted Data row's:", formattedData);
            // update here 'updateQUotationRow'

            const requests_1 = await QuotationService.patchQuotation(data_insert, data?.qu_no);
            const requests = await InvoiceService.updateQUotationRow(formattedData);

            console.log(requests_1);


            if (requests.status) {
                message.success(requests.message);
                const getRowData = await QuotationService.getAllQuotationById(eqData.qu_no);
                setDataSource(getRowData.data.quotation_data);
            } else {
                message.error(requests.message);
                const getRowData = await QuotationService.getAllQuotationById(eqData.qu_no);
                setDataSource(getRowData.data.quotation_data);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleAddPayment = async () => {
        try {
            const request = form.getFieldsValue();
            console.log("handleAddPayment", request.qu_no);

            console.log(data.qu_no);

            // save quotationNo and open modal
            setQuotationNo(data.qu_no);
            setPaymentModalOpen(true);
        } catch (error) {
            console.error("Error in handleAddPayment:", error);
        }
    };

    const handleGenerateInvoice = async () => {
        const request = form.getFieldsValue();

        console.log(request);
        if (!request.invoice_date) {
            return message.warning("Please select invoice date")
        }

        const user = await UserService.getOmeUser();

        const to_insert = {
            invoice_date: request.invoice_date,
            qu_no: eqData.qu_no,
            status: "Created",
            invoice_no: invoice_no,
            added_by: user.uid
        }

        const createInvoice = await InvoiceService.createInvoice(to_insert);
        console.log(createInvoice);

        if (createInvoice.status) {
            message.success(createInvoice.message);
            setPrintInvoice(true);
        } else {
            message.error(createInvoice.message);
        }

        console.log(to_insert);

    };


    const waitForImages = (container) => {
        const images = container.querySelectorAll("img");
        const promises = Array.from(images).map(img => {
            if (img.complete) return Promise.resolve();
            return new Promise((resolve, reject) => {
                img.onload = () => resolve();
                img.onerror = () => resolve(); // still resolve to avoid blocking PDF
            });
        });
        return Promise.all(promises);
    };

    const getBase64Image = (url) =>
        new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = "Anonymous"; // important for CORS
            img.onload = () => {
                const canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);
                resolve(canvas.toDataURL("image/png"));
            };
            img.onerror = reject;
            img.src = url;
        });


const handlePrintInvoice = async (qu_no) => {
  try {
    const quotationRes = await QuotationService.getAllQuotationById(qu_no);
    const quotation = quotationRes?.data?.quotation;
    const enquiryRes = await EnquiryService.getEnquiryDetailsById(quotation.eq_no);
    const enquiry = enquiryRes?.data;

    if (!quotation || !enquiry) {
      message.error("Data not found!");
      return;
    }

    // Convert dataSource to plain data
    const invoiceDataForPDF = dataSource.map(item => ({
      description: item.description || "",
      qty: item.qty || 0,
      unitprice: item.unitprice || 0,
      tax: item.tax || 0,
      totalprice: item.totalprice || 0
    }));

    // Get images
    const headerImageObj = letterHead.find(lh => lh.tag.toLowerCase() === 'header');
    const footerImageObj = letterHead.find(lh => lh.tag.toLowerCase() === 'footer');
    const watermarkObj = letterHead.find(lh => lh.tag.toLowerCase() === 'watermark');

    const headerBase64 = headerImageObj ? await getBase64Image(`${ENDPOINT.base}/${headerImageObj.image_url}`) : '';
    const footerBase64 = footerImageObj ? await getBase64Image(`${ENDPOINT.base}/${footerImageObj.image_url}`) : '';
    const dgSignBase64 = dgSign ? await getBase64Image(`${ENDPOINT.base}/${dgSign.image_path}`) : '';
    const watermarkBase64 = watermarkObj ? await getBase64Image(`${ENDPOINT.base}/${watermarkObj.image_url}`) : '';

    // Generate PDF using template (returns jsPDF doc)
    const pdfDoc = QuotationInvoiceTemplate({
      headerBase64,
      footerBase64,
      dgSignBase64,
      watermarkBase64,
      quotation,
      enquiry,
      quotationData: invoiceDataForPDF,
      invoice_date: selectedDate,
      invoice_no,
      grandTotal,
      numberToWords,
      selectedValue,
      bankAc,
      type: 'INVOICE',
        tax_type: form.getFieldValue('tax_type'),  // <-- Pass tax type
  tax_id: form.getFieldValue('tax_id'), 
   currency: enquiry.currency 
    });

    // Save the PDF
    // const safeCustomer = (enquiry?.name || "Customer").replace(/\s+/g, "_");
    // const fileName = `${invoice_no}_${safeCustomer}.pdf`;
    // pdfDoc.save(fileName);
  // Save the PDF
const fileName = `${invoice_no}.pdf`;
pdfDoc.save(fileName);


    
  } catch (error) {
    console.error(error);
    message.error("Failed to generate PDF!");
  }
};


    const handleClear = async () => {
        setDataSource([]);
        setBankAc(null);
        footerForm.resetFields();
    };

    return (
        <>
            {msgContc}
            <Form form={form} layout="vertical" style={{ width: "100%" }}>
                <Row gutter={[16, 16]}>
                    {/* Invoice Date */}
                    <Col xs={24} sm={12} md={8}>
              <Form.Item
    label="Invoice Date"
    name="invoice_date"
    style={{ width: "100%" }} // ✅ remove initialValue
>
    <DatePicker
        style={{ width: "100%" }}
        size="large"
        format="DD-MM-YYYY"
        onChange={(date) => {
            if (date) {
                setSelectedDate(dayjs(date).format("YYYY-MM-DD")); // keep state updated
            } else {
                setSelectedDate(null);
            }
        }}
    />
</Form.Item>

                    </Col>

                    {/* Tax Type */}
                    <Col xs={24} sm={12} md={8}>
                        <Form.Item
                            label="Tax type"
                            name="tax_type"
                            initialValue={data?.tax_type}
                            style={{ width: "100%" }}
                        >
                            <AutoComplete
                                allowClear
                                style={{ width: "100%" }}
                                options={options}
                                onSearch={handleSearch}
                                placeholder="Enter Tax type (e.g. GST, VAT)"
                                size="large"
                            />
                        </Form.Item>
                    </Col>

                    {/* Tax ID */}
                    <Col xs={24} sm={12} md={8}>
                        <Form.Item
                            label="Tax ID"
                            name="tax_id"
                            initialValue={data?.tax_id}
                            style={{ width: "100%" }}
                        >
                            <Input
                                allowClear
                                placeholder="Enter Tax ID (e.g. 09AAACH7409R1ZZ)"
                                size="large"
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>


            <Card style={{ marginTop: '30px', borderBlockColor: 'black' }}>
                <div>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            position: "relative",
                            height: "64px",
                        }}
                    >
                        

                        <Button
                            disabled={!Eqslected}
                            icon={<PlusOutlined />}
                            size="large"
                            type="primary"
                            onClick={handleNewAdd}
                        >
                            Add Row
                        </Button>

                    </div>

                    <Table
                        dataSource={dataSource}
                        columns={columns}
                        pagination={false}
                        rowKey="key"
                        summary={() => {
                            let totalQty = 0;
                            let totalprice = 0;

                            dataSource.forEach(({ qty, totalprice: rowTotal }) => {
                                totalQty += qty || 0;
                                totalprice += rowTotal || 0;
                            });

                            return (
                                <Table.Summary.Row>
                                    <Table.Summary.Cell index={0} colSpan={2}>
                                        <Text strong>Total</Text>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell index={2}>
                                        <Text strong>{totalQty}</Text>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell index={3}></Table.Summary.Cell>
                                    <Table.Summary.Cell index={4}>
                                        <Text strong>{totalprice}</Text>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell index={5}></Table.Summary.Cell>
                                </Table.Summary.Row>
                            );
                        }}
                    />

                    <Row style={{ marginTop: 16 }}>
                        <Col span={12}>
                            <Text italic>In Words: {numberToWords(grandTotal)}</Text>
                        </Col>
                        <Col span={12} style={{ textAlign: "right" }}>
                            <Text strong>Grand Total: {grandTotal}</Text>
                        </Col>
                    </Row>

                    <Row style={{ display: "flex", gap: 16, marginTop: 16 }}>
                        {/* Column 1 */}
                        <Col style={{ flex: 1, minWidth: 250 }}>
                            <Form form={footerForm} layout="vertical">
                                <Form.Item label="Select Terms & Condition" style={{ width: "100%" }}>
                                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                        <Select
                                            placeholder="Select option"
                                            options={selectedTCOption}
                                            size="large"
                                            value={selectedValue?.value}
                                            style={{ flex: 1 }}
                                            onChange={(value, option) => setSelectedValue(option)}
                                        />
                                        <Button type="link" onClick={handlePreview}>
                                            Preview
                                        </Button>
                                    </div>

                                    <Modal
                                        title="Preview of selected T&C"
                                        open={isModalOpen}
                                        footer={null}
                                        onCancel={() => setIsModalOpen(false)}
                                    >
                                        {selectedValue?.data ? (
                                            <div
                                                style={{
                                                    padding: "10px",
                                                    border: "1px solid #f0f0f0",
                                                    borderRadius: "8px",
                                                    background: "#fafafa",
                                                    minHeight: "100px",
                                                }}
                                                dangerouslySetInnerHTML={{ __html: selectedValue.data }}
                                            />
                                        ) : (
                                            <p>No data selected</p>
                                        )}
                                    </Modal>
                                </Form.Item>
                            </Form>
                        </Col>

                        {/* Column 2 */}
                        <Col style={{ flex: 1, minWidth: 250 }}>
                            <Form form={footerForm} layout="vertical">
                                <Form.Item
                                    label="Select Bank Account"
                                    name="bank_ac"
                                    rules={[{ required: true, message: "Please select an option!" }]}
                                >
                                    <Select
                                        placeholder="Select option"
                                        options={bankAcOption}
                                        value={bankAc?.value}
                                        size="large"
                                        style={{ width: "100%" }}
                                        onChange={(value, option) => setBankAc(option)}
                                    />
                                </Form.Item>
                            </Form>
                        </Col>

                        {/* Column 3 */}
                        <Col style={{ flex: 1, minWidth: 250 }}>
                            <Form layout="vertical">
                                <Form.Item
                                    label="Second Digital signature"
                                    name="dgselect"
                                    rules={[{ required: true, message: "Please select an option!" }]}
                                >
                                    <Select
                                        allowClear
                                        placeholder="Select option"
                                        options={dgSignOption}
                                        value={dgSign?.value}
                                        size="large"
                                        style={{ width: "100%" }}
                                        optionRender={(option) => option.data.label}
                                        fieldNames={{ label: "title", value: "value" }}
                                        onChange={(value, option) => setDGsign(option)}
                                    />
                                </Form.Item>
                            </Form>
                        </Col>
                    </Row>


                    <Row justify="end" style={{ marginTop: 16 }}>
                        <Divider />
                        <Space>

                            <Button disabled={!Eqslected} size="large" onClick={handleAddPayment}>
                                Add payment Amount
                            </Button>

                            <Popconfirm title="Sure to clear?" onConfirm={handleClear}>
                                {/* <Button disabled={!Eqslected} danger size="large">
                                    Clear
                                </Button> */}
                            </Popconfirm>

                            <Button disabled={!Eqslected} size="large" onClick={handleSave}>
                                Update
                            </Button>

                            <Button disabled={!Eqslected} size="large" type="primary" onClick={handleGenerateInvoice}>
                                Generate Invoice
                            </Button>

                            <Button size="large" disabled={!printInvoice} type="primary" onClick={() => handlePrintInvoice(eqData?.qu_no)} >
                                Print Invoice
                            </Button>


                        </Space>
                    </Row>
                </div>

                <Modal
                    width={800}
                    title={
                        <Typography.Title level={4}>Add Payment for: {quotationNo}</Typography.Title>
                    }
                    open={paymentModalOpen}
                    onCancel={() => setPaymentModalOpen(false)}
                    footer={null}
                    destroyOnClose
                >
                    {quotationNo && <CreatePayment quotationNo={quotationNo} grandTotal={grandTotal} />}
                </Modal>
            </Card>
        </>
    );
};

export default AddInvoiceData;